var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7363 12.0984C14.7363 12.427 14.4712 12.6934 14.1442 12.6934H5.85475C5.52774 12.6934 5.26264 12.427 5.26264 12.0984C5.26264 11.7698 5.52774 11.5034 5.85475 11.5034H14.1442C14.4712 11.5034 14.7363 11.7698 14.7363 12.0984Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1442 9.52005C14.4712 9.52005 14.7363 9.25365 14.7363 8.92504C14.7363 8.59643 14.4712 8.33004 14.1442 8.33004H5.85475C5.52774 8.33004 5.26264 8.59643 5.26264 8.92504C5.26264 9.25365 5.52774 9.52005 5.85475 9.52005H14.1442Z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07843 0C3.2064 0 2.49949 0.710379 2.49949 1.58667V14.4133H0.789474C0.353459 14.4133 0 14.7685 0 15.2067C0 15.6448 0.353459 16 0.789474 16H19.2105C19.6465 16 20 15.6448 20 15.2067C20 14.7685 19.6465 14.4133 19.2105 14.4133H17.4995V1.58667C17.4995 0.710378 16.7926 0 15.9205 0H4.07843ZM4.07843 14.2801V6.74337H15.9205V14.2801H4.07843Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardDoor);
export default __webpack_public_path__ + "static/media/StandardDoor.3cd2f554ed2aa452ddf2ee1c4c564ff5.svg";
export { ForwardRef as ReactComponent };